import React from 'react';
import {TaskTypeEnum} from 'src/api/ProactApiClient';
import {ApprovalEditor} from 'src/app/approvals/ApprovalForm';
import {AssignedFormEditor} from 'src/app/assigned-forms/AssignedForm';
import {ToolboxTalkEditor} from 'src/app/toolbox-talks/ToolboxTalkForm';
import type {TaskFeatureEditorProps} from './taskFeatureTypes';

export interface TaskFeatureEditorDispatcherProps
  extends TaskFeatureEditorProps {
  taskType: TaskTypeEnum;
}

export const TaskFeatureEditor: React.FC<TaskFeatureEditorDispatcherProps> = ({
  taskType,
  ...props
}) => {
  switch (taskType) {
    case TaskTypeEnum.ToolboxTalk:
      return <ToolboxTalkEditor {...props} />;
    case TaskTypeEnum.Form:
      return <AssignedFormEditor {...props} />;
    case TaskTypeEnum.Approval:
      return <ApprovalEditor {...props} />;
    default:
      return null;
  }
};
